// Funciones PURAS de conversión de moneda (ARS/USD/constante).
// Sin React ni side-effects → testeables. Usadas por MonedaContext.
import { formatMoney, formatNumber } from '../utils/formatNumber';

export type Moneda = 'ARS' | 'USD' | 'constante';

/**
 * Convierte un monto ARS a la moneda indicada.
 * - ARS: tal cual.
 * - USD: ars / usdRate (dólar blue/oficial de la fecha).
 * - constante: ars × (uvaHoy / uvaEntonces) — ajuste por inflación con CER.
 * Si falta el rate/UVA, devuelve ars sin convertir (fallback elegante).
 */
export function convertirMonto(
  ars: number,
  moneda: Moneda,
  usdRate: number | null,
  uvaHoy: number | null,
  uvaEntonces: number | null
): number {
  if (moneda === 'ARS' || !ars) return ars;
  if (moneda === 'USD') return usdRate ? ars / usdRate : ars;
  // constante
  return uvaHoy && uvaEntonces ? ars * (uvaHoy / uvaEntonces) : ars;
}

/**
 * Formatea un valor YA convertido con el símbolo de la moneda.
 * ARS → $, USD → u$, constante → c$.
 */
export function formatMonedaSimbolo(value: number, moneda: Moneda): string {
  if (moneda === 'USD') return `u$ ${formatNumber(value, { decimals: 2 })}`;
  if (moneda === 'constante') return `c$ ${formatNumber(value, { decimals: 0 })}`;
  return formatMoney(value); // ARS
}

/** Símbolo corto de la moneda para labels/headers: ARS→$, USD→u$, constante→c$.
 *  Útil para que los headers digan "Monto ($)" en cualquier país (no "ARS"). */
export function simboloMoneda(moneda: Moneda): string {
  if (moneda === 'USD') return 'u$';
  if (moneda === 'constante') return 'c$';
  return '$';
}
